module.exports = __webpack_public_path__ + "static/img/ico_notice.2bde106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check/ico_notice.png
// module id = YhrO
// module chunks = 10